import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSnsNaverpost(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "21",
    fill: "none",
    viewBox: "0 0 13 21",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D92",
    fillRule: "evenodd",
    d: "M.5 12.5V.5h12v12zm6.96-3.26H9.5v-5.5H7.48v2.84L5.54 3.74H3.5v5.5h2.02V6.4zM3.08 16.662h6.84l2.58-2.983H.5zm3.42 3.954 2.4-2.775H4.1z",
    clipRule: "evenodd"
  }));
}
var IcSnsNaverpost = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSnsNaverpost));

export { IcSnsNaverpost as I };
